<script setup>
import { computed, useAttrs } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';

const attrs = useAttrs();
const globalConfig = useMapGetter('globalConfig/get');

// 没有上传品牌图片时显示安装名称首字母，避免回退到上游项目图标。
const brandInitial = computed(() =>
  (globalConfig.value.installationName || 'J').trim().slice(0, 1).toUpperCase()
);
</script>

<template>
  <img
    v-if="globalConfig.logoThumbnail"
    v-bind="attrs"
    :src="globalConfig.logoThumbnail"
    alt=""
  />
  <span
    v-else
    v-bind="attrs"
    class="inline-grid place-items-center rounded-md bg-n-brand font-semibold leading-none text-white"
    aria-hidden="true"
  >
    {{ brandInitial }}
  </span>
</template>
